/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import iconSet from 'quasar/icon-set/material-symbols-rounded.js'



import {QSpinnerBars,Dialog,Loading,LoadingBar,Meta,Notify} from 'quasar'



const userOptions = { config: {"loading":{"spinner":"QSpinnerBars"},"loadingBar":{"color":"primary","size":"3px","position":"top"},"brand":{"default":"#3e3e3e","primary":"#604a44","secondary":"#ff6e40","accent":"#0075e4","hint":"#bcbcbc","positive":"#0dc667","negative":"#f44336","info":"#00a8ff","warning":"#f3b700"}},iconSet,components: {QSpinnerBars},plugins: {Dialog,Loading,LoadingBar,Meta,Notify} }
  
userOptions.config.loading.spinner = QSpinnerBars
  
  
export default userOptions

